@if (isRmbRmc) {
<div>
  <span>{{ staticText | globalTranslate }}</span>
</div>
} @if (isRmbRmc && this.selectedIndividual) {
<div><br /></div>
} @if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <p class="person-label">{{ selectedIndividual | fullname }}</p>
</div>
}<br />
<nh-form
  [topLevelName]="'re'"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  [formGroup]="getForm()"
  class="label-section"
  topLevelQuestion="{{ 'RESOURCES_PROPERTY_TOPLEVEL' | globalTranslate }}"
  popupText="{{ 'RESOURCES_PROPERTY_POPUP' | globalTranslate }}"
  individualQuestion="{{
    'RESOURCES_PROPERTY_INDIV_QUESTION' | globalTranslate
  }}"
  [hintText]="hintText"
  (validate)="onValidate($event)"
  (individualAnswerChanged)="onIndividualChange($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "RESOURCES_PROPERTY_STATIC1" | globalTranslate }}
    </h1>
    <hr />
    <nh-field
      id="re_assetType"
      label="{{ 'RESOURCES_PROPERTY_STATIC2' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'VEHICLE_STATIC_TEXT3' | globalTranslate }}<div class=hint>{{
        'IF' | globalTranslate
      }} {{ selectedIndividual | fullname }} {{
        'RESOURCES_PROPERTY_STATIC3' | globalTranslate
      }}</div>"
      class="label-section"
    >
      <select
        nhTranslate
        name="assetType"
        [attr.aria-label]="
          ('RESOURCES_PROPERTY_STATIC2' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('VEHICLE_STATIC_TEXT3' | globalTranslate)
        "
        [items]="tableCodeValue('MPPROPTYPE', 'data.assetType')"
        formControlName="assetType"
        required
      ></select>
    </nh-field>

    <nh-alert type="warning" [isOpen]="isHome">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span
            >{{ "RESOURCES_PROPERTY_ERROR1" | globalTranslate }}
            {{ selectedIndividual | fullname }}
            {{ "RESOURCES_PROPERTY_ERROR2" | globalTranslate }}
            {{ selectedIndividual | fullname
            }}{{ "RESOURCES_PROPERTY_ERROR3" | globalTranslate }}</span
          >
        </div>
      </div>
    </nh-alert>
    <nh-field
      id="re_landUseCode"
      label="{{ 'RESOURCES_PROPERTY_STATIC4' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="landUseCode"
        [attr.aria-label]="'RESOURCES_PROPERTY_STATIC4' | globalTranslate"
        [items]="tableCodeValue('REALPROPERTYUSE', 'data.landUseCode')"
        (change)="validateLandUseCode()"
        formControlName="landUseCode"
        required
      ></select>
    </nh-field>

    @if (isEnabled('data.primaryResidence')) {
    <nh-field
      id="re_primaryResidence"
      label="{{ 'DOES_2' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'RESOURCES_PROPERTY_STATIC5' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="primaryResidence"
        [attr.aria-label]="
          ('DOES_2' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('RESOURCES_PROPERTY_STATIC5' | globalTranslate)
        "
        [items]="tableCodeValue('YESNO', 'data.primaryResidence')"
        formControlName="primaryResidence"
        required
      ></select>
    </nh-field>
    } @if (isEnabled('data.intendToReturn')) {
    <nh-field
      id="re_intendToReturn"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'DOES_2' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'RESOURCES_PROPERTY_STATIC6' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="intendToReturn"
        [items]="tableCodeValue('YESNO', 'data.intendToReturn')"
        formControlName="intendToReturn"
        [attr.aria-label]="
          ('DOES_2' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('RESOURCES_PROPERTY_STATIC6' | globalTranslate)
        "
      ></select>
    </nh-field>
    } @if (isEnabled('data.rentHome')) {
    <nh-field
      id="re_rentHome"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'DOES_2' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'RESOURCES_PROPERTY_STATIC7' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="rentHome"
        [items]="tableCodeValue('YESNO', 'data.rentHome')"
        formControlName="rentHome"
        [attr.aria-label]="
          ('DOES_2' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('RESOURCES_PROPERTY_STATIC7' | globalTranslate)
        "
      ></select>
    </nh-field>
    } @if (isEnabled('data.monthlyIncome')) {
    <nh-field
      id="re_monthlyIncome"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'RESOURCES_PROPERTY_STATIC8' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          maxlength="7"
          name="monthlyIncome"
          formControlName="monthlyIncome"
          class="form-control"
          [attr.aria-label]="'RESOURCES_PROPERTY_STATIC8' | globalTranslate"
        />
      </nh-input-group>
    </nh-field>
    } @if (isEnabled('data.owedAmount')) {
    <nh-field
      id="re_owedAmount"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'VEHICLE_STATIC_TEXT9' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'RESOURCES_PROPERTY_STATIC9' | globalTranslate }} {{
        getValue('data.assetType').value | globalTranslate
      }}?"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          maxlength="7"
          name="owedAmount"
          formControlName="owedAmount"
          class="form-control"
          [attr.aria-label]="
            ('VEHICLE_STATIC_TEXT9' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('RESOURCES_PROPERTY_STATIC9' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value | globalTranslate)
          "
        />
      </nh-input-group>
    </nh-field>
    }

    <nh-field
      id="re_assetAmount"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'RESOURCES_PROPERTY_STATIC10' | globalTranslate }} {{
        getValue('data.assetType').value | globalTranslate
      }}?"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          maxlength="7"
          name="assetAmount"
          formControlName="assetAmount"
          class="form-control"
          [attr.aria-label]="
            ('RESOURCES_PROPERTY_STATIC10' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value | globalTranslate)
          "
        />
      </nh-input-group>
    </nh-field>

    <h2 class="section-header">
      {{ "RESOURCES_PROPERTY_STATIC11" | globalTranslate }}
    </h2>
    <hr />
    <nh-alert type="warning" [isOpen]="getControl('data.assetAddress').touched">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "ADDRESS_WARNING" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>

    <nh-name-address
      [addressname]="'re_assetAddress'"
      [addressFieldMandatory]="false"
      [stateDefault]="false"
      [showPopup]="false"
      [address]="getControl('data.assetAddress')"
      [tables]="tables"
      [hideCounty]="true"
    ></nh-name-address>
    <br />
    @if (selectedIndividual) {
    <div>
      <h2 class="section-header">{{ "CO-OWENERS_TITLE" | globalTranslate }}</h2>
      <hr />
      <nh-field
        id="re_jointOwnership"
        label="{{ 'VEHICLE_STATIC_TEXT14' | globalTranslate }} {{
          getValue('data.assetType').value | globalTranslate
        }} {{ 'VEHICLE_STATIC_TEXT15' | globalTranslate }} {{
          selectedIndividual | fullname
        }}? "
        class="label-section"
      >
        <div class="hint">
          {{ "VEHICLE_STATIC_TEXT16" | globalTranslate }}
          {{ selectedIndividual | fullname }}
          {{ "VEHICLE_STATIC_TEXT17" | globalTranslate }}
        </div>
        <select
          nhTranslate
          name="jointOwnership"
          [attr.aria-label]="
            ('VEHICLE_STATIC_TEXT14' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value | globalTranslate) +
            ' ' +
            ('VEHICLE_STATIC_TEXT15' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('VEHICLE_STATIC_TEXT16' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('VEHICLE_STATIC_TEXT17' | globalTranslate)
          "
          [items]="tableCodeValue('YESNO', 'data.jointOwnership')"
          formControlName="jointOwnership"
          aria-required="true"
        ></select>
      </nh-field>
      <div (window:resize)="onResize($event)"></div>
      @if (isY('data.jointOwnership')) {
      <div>
        <nh-co-owner
          [jointOwnershipInformation]="
            getControl('data.jointOwnershipInformation')
          "
          [formData]="getControl('data')"
          [addRowValid]="checkValid()"
          [coOwnerIndividuals]="coOwnerIndividuals"
          [error]="error"
          (emitValidate)="coOwnerValidate($event)"
          (errorMessage)="getErrorMessage($event)"
          [coOwnerIndivErrorMessage]="coOwnerIndivErrorMessage"
          (removeRow)="removeRow($event)"
          (addRow)="addRow()"
        ></nh-co-owner>
      </div>
      }
    </div>
    }
  </section>
</nh-form>